import { ListItemIcon, MenuItem } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import React, { Fragment, useState } from "react";
import {
	Button,
	Confirm,
	useCreate,
	useNotify,
	useTranslate
} from "react-admin";

const ImportAllButton = ({ selectedIds, isButton = false, basePath, ...props }) => {
	const translate = useTranslate();
	const notify = useNotify();
	const [open, setOpen] = useState(false);
	const handleClick = () => setOpen(true);
	const handleDialogClose = () => setOpen(false);
	const command = {
		name: "report",
		args: ["import", selectedIds.join(","), "--force"],
		notify_args: {
			title: translate("bookmakers.actions.import.notify_title", { name: "Bookmaker" }),
			content: translate("bookmakers.actions.import.notify_content"),
			resource: "bookmakers",
		},
	};
	const [create, { loading }] = useCreate("commands", command, {
		onSuccess: () => {
			notify("bookmakers.actions.import.success");
		},
	});
	const handleConfirm = () => {
		create();
		setOpen(false);
	};
	const label = translate("bookmakers.actions.import");
	return (
		<Fragment>
			{isButton ? (
				<Button
					disabled={loading}
					color="secondary"
					label={label}
					onClick={handleClick}
					{...props}
				>
					<GetAppIcon />
				</Button>
			) : (
					<MenuItem onClick={handleClick}>
						<ListItemIcon>
							<GetAppIcon size="small" />
						</ListItemIcon>
						{label}
					</MenuItem>
				)}
			<Confirm
				isOpen={open}
				loading={loading}
				title={translate("bookmakers.actions.import.title")}
				content={translate("bookmakers.actions.import.content")}
				onConfirm={handleConfirm}
				onClose={handleDialogClose}
			/>
		</Fragment>
	);
};

export default ImportAllButton;
